import React, { useEffect, useState } from 'react';
import _get from 'lodash-es/get';

import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircleFill } from 'sushiweb/Icons';
import green from 'sushiweb/tokens/color/green';
import red from 'sushiweb/tokens/color/red';
import H4 from 'sushiweb/Typography/Heading/H4';
import { P } from 'sushiweb/Typography/Text';
import CrossCircleFill from 'sushiweb/Icons/all/CrossCircleFill';
import Button from 'sushiweb/Button/Button';
import Spinner from 'sushiweb/Spinner/Spinner';
import TimeFill from 'sushiweb/Icons/all/TimeFill';
import yellow from 'sushiweb/tokens/color/yellow';

import {
  DashboardWrapper,
  OnlinePaymentCenterAlign,
  OnlinePaymentStatusHeader,
  RedirectNavlink,
  SpinnerHolder,
} from '../../../common/styles';
import { formatAmountInRupees, queryVariableValue } from '../../../../helpers';
import {
  currentFlowTypeEnum,
  paymentRequestEnum,
  paymentStatusEnum,
} from '../../../common/components/constants';
import usePaymentPolling from '../../../common/utils/usePaymentPolling';
import { GET_PAYMENT_REQUEST_LOG } from '../../../../constants/urls';
import { SingleLineArrow } from '../../../../components/SVGs/commonSVGs';
import ErrorPage from '../../../common/components/ErrorPage/ErrorPage';

const AdhocPaymentsSuccessPage = () => {
  const { paymentRequestID = '' } = useParams();
  const [isOrderIDpresent, orderIDValue] = queryVariableValue('order_id');
  const [pollingCounter, setPollingCounter] = useState(0);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isResponseError, setIsResponseError] = useState(false);
  const [isPollingStarted, setIsPollingStarted] = useState(true);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const [currentFlowType, setCurrentFlowType] = useState(0);
  const [paymentState, setPaymentState] = useState(
    paymentStatusEnum.INITIATED_PENDING,
  );
  const [paymentAmount, setPaymentAmount] = useState(0);
  const terminalStates = [
    paymentRequestEnum.EXPIRED,
    paymentRequestEnum.PAID,
    paymentRequestEnum.INACTIVE,
  ];
  console.log(isOrderIDpresent);

  const onResponse = ({ isError, response }) => {
    setPollingCounter(pollingCounter + 1);
    const respStatus = _get(response, 'status_response.status', false);
    setIsResponseError(!respStatus);
    const status = _get(response, 'data.status', 0);
    const amount = _get(response, 'data.amount', 0);
    const paymentStatus = _get(response, 'data.payment_status', 0);
    setCurrentFlowType(_get(response, 'data.flow_type', 0));
    setPaymentAmount(amount);
    setIsPageLoading(false);
    if (isError) {
      setIsPollingStarted(false);
      return;
    }
    if (!respStatus) {
      setIsPollingStarted(false);
    }
    if (paymentStatus === paymentStatusEnum.FAILED) {
      setPaymentState(paymentStatusEnum.FAILED);
      setIsPollingStarted(false);
    }
    if (paymentStatus === paymentStatusEnum.SUCCESS) {
      setPaymentState(paymentStatusEnum.SUCCESS);
      setIsPollingStarted(false);
    }
    if (terminalStates.includes(status)) {
      setIsPollingStarted(false);
      if (status === paymentRequestEnum.PAID)
        setPaymentState(paymentStatusEnum.SUCCESS);
    } else {
      setPollingFrequency(3);
    }
  };

  usePaymentPolling({
    paymentRequestID,
    frequency: pollingFrequency,
    isPollingStarted,
    onResponse,
    url: GET_PAYMENT_REQUEST_LOG,
  });

  const RedirectPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate(`/gifting`);
      }, 4000);

      return () => clearTimeout(timer);
    }, [navigate]);

    return <div />;
  };

  useEffect(() => {
    if (pollingCounter === 10) {
      if (paymentState !== paymentStatusEnum.SUCCESS) {
        setPaymentState(paymentStatusEnum.PENDING);
      }
      setIsPollingStarted(false);
    }
  }, [pollingCounter]);
  if (isResponseError) {
    return (
      <>
        <DashboardWrapper>
          <ErrorPage />
        </DashboardWrapper>
      </>
    );
  }
  return (
    <>
      {isPageLoading ? (
        <>
          <DashboardWrapper>
            <SpinnerHolder className='center'>
              <Spinner color={red.z_red} size='medium' />
            </SpinnerHolder>
          </DashboardWrapper>
        </>
      ) : (
        <DashboardWrapper>
          {paymentState === paymentStatusEnum.SUCCESS && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CheckCircleFill
                        color={green.z500}
                        size='18rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Your payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        is
                        successful.
                        {' '}
                        <br />
                        {' '}
                        Ref. ID:&nbsp; ZFE
                        {orderIDValue.toString().padStart(6, '0')}
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    {currentFlowType !==
                      currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD ? (
                        <P>
                          Enterprise balance will be assigned to the employees
                          within the next 10 minutes
                          <br />
                          {' '}
                          Employees will be notified on their Email ID
                          {' '}
                          <br />
                          <br />
                          The reimbursement note has been sent to your Email ID
                        </P>
                    ) : (
                      <P>
                        The gift card details will be sent to the recipients
                        Email ID within the next 10 minutes
                        <br />
                        <br />
                        The reimbursement note has been sent to your Email ID
                        <br />
                        <br />
                        Redirecting to Gifting page...
                        <RedirectPage />
                      </P>
                    )}
                  </div>
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
          {paymentState === paymentStatusEnum.INITIATED_PENDING && (
            <SpinnerHolder className='center'>
              <Spinner color={red.z_red} size='medium' />
            </SpinnerHolder>
          )}
          {paymentState === paymentStatusEnum.PENDING && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <TimeFill
                        color={yellow.z500}
                        size='18rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Your payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        is
                        pending
                        {' '}
                        <br />
                        {' '}
                        Ref. ID:&nbsp; ZFE
                        {orderIDValue.toString().padStart(6, '0')}
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    <P>
                      If money was deducted, a refund will be automatically
                      initiated within 24 hours
                    </P>
                    {currentFlowType ===
                      currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD && (
                        <RedirectPage />
                      )}
                  </div>
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
          {paymentState === paymentStatusEnum.FAILED && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CrossCircleFill
                        color={red.z500}
                        size='18rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        failed
                        {' '}
                        <br />
                        {' '}
                        Ref. ID:&nbsp; ZFE
                        {orderIDValue.toString().padStart(6, '0')}
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    <P>
                      If money was deducted, a refund will be automatically
                      initiated within 24 hours
                      <br />
                      {' '}
                      <br />
                      Please retry the payment using a different payment method
                    </P>
                  </div>
                  <br />
                  {' '}
                  <br />
                  <RedirectNavlink to={`/online-payment/${paymentRequestID}`}>
                    <Button icon={<SingleLineArrow />} iconAlign='right'>
                      Retry payment
                    </Button>
                  </RedirectNavlink>
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
        </DashboardWrapper>
      )}
    </>
  );
};

export default AdhocPaymentsSuccessPage;
